import classnames from 'classnames';
import React from 'react';

import { SafeMarkdown } from 'src/lib/safeCompileMarkdown';

import { CustomComponentsOrParagraph } from './CustomComponentsOrParagraph';
import { useGetUsersForMentions } from './useMentionUsers';

export const SafeCommentMarkdown = React.forwardRef<
  HTMLDivElement,
  {
    comment: string;
    className: string;
    usersForMentions: ReturnType<typeof useGetUsersForMentions>;
  }
>(({ comment, className, usersForMentions }, ref) => {
  const customComponentsOrParagraphProps: Omit<
    React.ComponentProps<typeof CustomComponentsOrParagraph>,
    'children'
  > = {
    className: 'mt-0 mb-3 text-base',
    usersLoading: false,
    users: usersForMentions.users,
  };

  return (
    <SafeMarkdown
      className={classnames(className, 'text-primary')}
      markdown={usersForMentions.transformInputForMarkdown(comment)}
      includeDefaultOverrides={true}
      shouldPopulateEmojis={true}
      ref={ref}
      options={{
        forceBlock: true,
        overrides: {
          p: {
            component: CustomComponentsOrParagraph,
            props: customComponentsOrParagraphProps,
          },
          span: {
            component: CustomComponentsOrParagraph,
            props: customComponentsOrParagraphProps,
          },
        },
      }}
    />
  );
});
